import { FullSite } from "../../../../dtos/site";

export enum StatsKey {
    AllSites = "allSites",
    OnlineSites = "onlineSites",
    ActiveAlarm = "activeAlarm",
    SiteOffline = "siteOffline",
    RoomBoxLeftOpen = "roomBoxLeftOpen",
    RoomEntryUnauthorized = "roomEntryUnauthorized",
    RoomInUse = "roomInUse",
    RoomIdle = "roomIdle",
}

export interface SitesStatsResult {
    sitesOffline: FullSite[];
    sitesOnline: FullSite[];
    sitesWithAlarm: FullSite[];
    sitesWithRoomBoxLeftOpen: FullSite[];
    sitesWithRoomEntryUnauthorized: FullSite[];
    sitesWithRoomInUse: FullSite[];
    sitesWithRoomIdle: FullSite[];
    issueCount: number;
}
